import ModalAdminCustom from './ModalAdminCustom';

export default ModalAdminCustom;
